export default __webpack_public_path__ + "static/media/css.b6fb6f37.png";